/* eslint-disable array-callback-return */
import { Modal } from "react-bootstrap";
import {
  popCancelBttn,
  exclaimIcn,
  imsLoader
} from "../../assets";
import { Component } from "react";
import Button from "../Button";
import ApiServices from "../../utils/apiServices";
import RenamePubMedSaveSearchPopup from "./RenamePubMedSaveSearchPopup";
import { v4 as uuidv4 } from "uuid";
import SucessReadingList from "./SucessReadingList";
import { snippetLongString, LocationOrigin, getCurrentDate } from "../../utils/utilityServices";
import "./GlobalSearchFeaturesPopUp.css";
import "./PubMedSaveSearchPopup.css";
import AlertMessagePopUpModal from "./AlertMessagePopUpModal";
import ConfirmMessagePopUpModal from "./ConfirmMessagePopUpModal"
import moment from 'moment';
import axios from "axios";
import trackingService from "../../services/trackingService";
import { Authentication } from "../../utils/authenticationUtilityServices";
import SharePubMedModal from "./SharePubmedModal";


let _locationOrigin = LocationOrigin;
//_locationOrigin = 'https://predev-ims.jnj.com';
class PubMedSaveSearchPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPop: false,
      isPin: true,
      isinfo: true,
      isManage: false,
      apiResponse: [],
      isLoaded: false,
      showRenamePop: false,
      itemtoBeRenamedName: "",
      itemtoBeRenamedID: "",
      error: "",
      saveSearchName: "",
      docID: [],
      showSuccess: false,
      isInsertSuccess: false,
      selectedSaveSearches: [],
      successMessage: "",
      nodeName: "",
      alertMessageModelColor: "",
      alertMessageContent: "",
      alertMessageShowModal: false,
      confirmMessageContent: '',
      confirmMessageShowModal: false,
      confirmMessageId: -1,
      confirmXSearchId: -1,
      selectedTab: this.props.selectedTab,
      pubMedXSearchId: this.props.pubMedXSearchId,
      searchKeyword: props.searchKeyword,
      fromYear: props.fromYear,
      toYear: props.toYear,
      appliedFilters: props.appliedFilters,
      useTemplate: props.useTemplate ? props.useTemplate : "",
      selectedTab: props.selectedTab ? props.selectedTab : "-1",
      shareModal: false,
      saveSearchItem: {}
    };
  }
  async componentDidMount() {
    let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
    let service = new ApiServices();
    if (
      this.props.selectedResults.length <= 0 ||
      this.props.selectedResults.length > 200
    ) {
      this.setState({
        isManage: true,
        isPin: false,
        isinfo: false,
      });
    } else {
      this.setState({
        docID: this.props.selectedResults.map((item) => item.resultID),
      });
    }
    this.setState({
      showPop: this.props.showModal,
    });
    let apiRes = await service.getPubMedSaveSearches(username);
    this.setState(
      {
        apiResponse: apiRes,
        //isLoaded: true
      },
      async () => {
        await this.getPubMedSaveSearchesWithDocIds();
      }
    );
  }

  showConfirmMessage = (message, id, searchId) => {
    this.setState({
      confirmMessageContent: message,
      confirmMessageShowModal: true,
      confirmMessageId: id,
      confirmXSearchId: searchId,
    })
  }

  confirmHandler = async () => {
    const { confirmMessageId, confirmXSearchId } = this.state;
    let username = JSON.parse(localStorage.getItem('username'))
    if (username) {
      username = username.toLowerCase();
    }
    let service = new ApiServices();
    this.setState({ isLoaded: false });
    let pubmedReviewResponse = await this.updatePubmedSavedFlag(confirmXSearchId, false);
    if (!pubmedReviewResponse.errors) {
      await service.deletePubMedSaveSearches(confirmMessageId, username);
      this.setState(
        {
          isLoaded: false,
          confirmMessageContent: "",
          confirmMessageShowModal: false,
          confirmMessageId: -1,
          confirmXSearchId: -1,
        },
        async () => {
          let { selectedSaveSearches } = this.state
          let apiRes = await service.getPubMedSaveSearches(username);
          let savesearchIds = apiRes.map(x => x.savesearch_id);
          selectedSaveSearches = selectedSaveSearches.filter(x => savesearchIds.includes(x.savesearch_id));
          this.setState(
            {
              apiResponse: apiRes,
              isLoaded: true,
              selectedSaveSearches: selectedSaveSearches
            },
            async () => {
              await this.getPubMedSaveSearchesWithDocIds();
              this.props.handleRemoveSaveSearch(confirmMessageId)
            }
          );
        }
      );
    } else {
      this.setState(
        {
          isLoaded: true,
          confirmMessageContent: "",
          confirmMessageShowModal: false,
          confirmMessageId: -1,
          confirmXSearchId: -1,
        }, () => {

          this.errorAlertMessage("Something Went Wrong. Kindly try after some time.");
        })
    }

  }
  deletesaveSearchBySaveSearchId = async (saveSearchId) => {
    var url = `${LocationOrigin}${process.env.REACT_APP_IMS_API_PUBMED_REVIEWLIST}drlbysaveSearchId?saveSearchId=${saveSearchId}`
    let res = { "statusCode": 500 };
    const _headers = {
      'Content-Type': 'application/json'
    };
    if (await Authentication.isAccessTokenAvailable()) {
      // No Authorization header provided, attach the default one
      const token = await Authentication.getAccessToken();
      _headers.Authorization = `Bearer ${token}`;
    }
    await axios
      .delete(url, { headers: _headers })
      .then((response) => {
        res = response.data;
      })
      .catch((error) => {
        console.log(error);
        res = { "statusCode": 500 };
      });
    return res;
  }
  closeConfirmMessage = () => {
    this.setState({
      confirmMessageContent: "",
      confirmMessageShowModal: false,
      confirmMessageIndex: -1
    })
  }
  errorAlertMessage = (message) => {
    this.setState({
      alertMessageContent: message,
      alertMessageModelColor: "#de1327",
      alertMessageShowModal: true
    })
  }

  closeAlertMessage = () => {
    this.setState({
      alertMessageContent: "",
      alertMessageModelColor: "",
      alertMessageShowModal: false
    })
  }
  getPubMedSaveSearchesWithDocIds = async () => {
    let { apiResponse } = this.state;
    let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
    let service = new ApiServices();
    let apiRes = await service.getPubMedSaveSearchesWithDocIds(username);
    let doneArr = [];
    if (apiRes) {
      apiRes.map((item) => {
        let _docCount = item.doc_id.split(";").length;
        if (!doneArr.find((x) => x === item.savesearch_id)) {
          _docCount += this.props.selectedResults.length;

          let _selectedSaveSearch = apiResponse.find(
            (x) => x.savesearch_id === item.savesearch_id
          );

          _selectedSaveSearch.docCount =
            _selectedSaveSearch.docCount === undefined
              ? _docCount
              : _selectedSaveSearch.docCount + _docCount;

          _selectedSaveSearch.doc_id = item.doc_id;
        } else {
          let _selReadList = apiResponse.find(
            (x) => x.savesearch_id === item.savesearch_id
          );

          _selReadList.doc_id =
            _selReadList.doc_id !== undefined
              ? _selReadList.doc_id + ";" + item.doc_id
              : item.doc_id;

          _selReadList.doc_id = Array.from(
            new Set(_selReadList.doc_id.split(";"))
          );

          _selReadList.docCount =
            _selReadList.doc_id.length + this.props.selectedResults.length;
        }

        doneArr.push(item.savesearch_id);
      });
      this.setState({
        apiResponse: apiResponse,
        isLoaded: true,
      });
    }
  };

  handleOnClickView = async (rlID, rName) => {
    let ids = "";
    let service = new ApiServices();
    let res = await service.getPubMedReviewDocIds(rlID);
    if (res.length > 0) {
      ids = res.map(item => item.doc_id).filter(x => x).join(";");
      // res.map((item) => {
      //   ids += `${item.doc_id};`;
      //   return null;
      // });
    }
    localStorage.setItem("readListDocIds", ids);
    localStorage.setItem("rLID", rlID);
    localStorage.setItem("rName", rName);
    let url = `/viewPubMedSaveSearch?query=&q=All%20Fields&filters=&f1=PMID&fval1=${ids}&fcount=1&rName=${encodeURIComponent(
      rName
    )}&rID=${rlID}`;
    if (ids !== "") {
      window.open(url, "_blank");
    } else {
      this.errorAlertMessage("You do not have any items pinned to this save search.");
    }
  };
  handleRename = (id, name) => {
    this.setState({
      showRenamePop: true,
      itemtoBeRenamedName: name,
      itemtoBeRenamedID: id,
    });
  };
  handleRenameClose = (status) => {
    this.setState(
      {
        showRenamePop: status,
        isLoaded: false,
      },
      async () => {
        let username = JSON.parse(
          localStorage.getItem("username")
        ).toLowerCase();
        let service = new ApiServices();
        let apiRes = await service.getPubMedSaveSearches(username);
        this.setState(
          {
            apiResponse: apiRes,
            //isLoaded: true
          },
          async () => {
            await this.getPubMedSaveSearchesWithDocIds();
          }
        );
      }
    );
  };
  handleRemove = async (id, searchId) => {
    this.showConfirmMessage("Are you sure you want to delete this save search ?", id, searchId)
  };
  handleValidation() {
    let errors = {};
    let formIsValid = true;
    let saveSearch = this.state.apiResponse.map((data) =>
      data.savesearch_name.toLowerCase()
    );
    if (
      this.state.saveSearchName.length <= 0 /*&&
      this.state.selectedSaveSearches.length <= 0 &&
      this.state.nodeName !== "INPUT"*/
    ) {
      formIsValid = false;
      this.errorAlertMessage("Please enter a New Save Search name.")
      // errors["pinSaveSearch"] = 'Please enter a valid name to proceed.';
    }
    /*if (
      this.state.saveSearchName.length <= 0 &&
      this.state.nodeName === "INPUT" &&
      this.state.selectedSaveSearches.length <= 0
    ) {
      formIsValid = false;
      errors["pinSaveSearch"] = `Please enter a valid name to proceed.`;
    }*/
    if (saveSearch.includes(this.state.saveSearchName.toLowerCase())) {
      formIsValid = false;
      errors[
        "pinSaveSearch"
      ] = `You already have a save search with entered title. Please enter a new title.`;
    }
    this.setState({ error: errors });
    return formIsValid;
  }
  handleCheckBox = (e, itemCounts) => {
    if (itemCounts <= 200 || itemCounts === undefined) {
      let arr = this.state.selectedSaveSearches;
      if (e.target.checked) {
        arr.push(e.target.value);
      } else {
        var idx = arr.indexOf(e.target.value);
        if (idx !== -1) {
          arr.splice(idx, 1);
        }
      }
      this.setState({
        selectedSaveSearches: arr,
      });
    } else {
      e.preventDefault();
      e.returnValue = false;
      this.errorAlertMessage("A user may only add a maximum of 200 items in a save search.");
    }

  };
  handleOnFocusInput = (e) => {
    this.setState({ nodeName: e.target.nodeName });
  };
  handleInput = (e) => {
    e.target.value = snippetLongString(e.target.value);
    this.setState({
      saveSearchName: e.target.value,
    });
  };
  generateArrayString = (array) => {
    try {
      let arrStr = "";
      array.map((item, index) => {
        if (index === array.length - 1) {
          arrStr += item;
        } else {
          arrStr += item + ";";
        }
        return null;
      });
      return arrStr;
    } catch (error) {
      this.setState({ error: error });
    }
  };
  handleViewSaveSearch = (selectedSaveSearchPubMedXSearchId, searchKeyword, filterStr, fromYear, toYear, savesearchName, savesearch_id,) => {
    this.props.handleViewSaveSearch(selectedSaveSearchPubMedXSearchId, searchKeyword, filterStr, fromYear, toYear, savesearchName, savesearch_id)
  }
  indexData = (saveSearchId, filterStr) => {
    let { saveSearchName, pubMedXSearchId, searchKeyword, fromYear, toYear, useTemplate } = this.state;
    let _saveSearchinfo = {
      saveSearchName: saveSearchName,
      saveSearchId: saveSearchId,
      pubMedXSearchId: pubMedXSearchId,
      keyword: searchKeyword,
      fromYear: fromYear,
      toYear: toYear,
      filters: filterStr
    }
    let _eventaction = 'Save Search';
    if (this.state.selectedTab === '0') {
      _eventaction = "Save Search PubMedGenAI2.0 in PubMed Tab";
    }
    else if (this.state.selectedTab === '1') {
      _eventaction = `Save Search PubMedGenAI2.0 with ${useTemplate} Template in Upload Abstracts Tab`;
    }
    else if (this.state.selectedTab === '2') {
      _eventaction = "Save Search PubMedGenAI2.0 in Review List Tab";
    }
    else if (this.state.selectedTab === '3') {
      _eventaction = "Save Search PubMedGenAI2.0 in Saved Searches Tab";
    }
    const ts = new trackingService();
    ts.indexTrackingData(localStorage.getItem('userdisplayName'),
      localStorage.getItem('wwid'),
      localStorage.getItem('username'),
      localStorage.getItem('function'),
      localStorage.getItem('region'),
      localStorage.getItem('userproducts'),
      localStorage.getItem('doctypepref'),
      localStorage.getItem('sid'),
      localStorage.getItem('deviceType'),
      localStorage.getItem('deviceOS'),
      localStorage.getItem('browserName'),
      localStorage.getItem('browserVersion'),
      localStorage.getItem('jnjDepartment'),
      localStorage.getItem('companyname'),
      _eventaction,
      '',
      window.location.href, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', {}, {}, {}, _saveSearchinfo);
  }
  onclickProceed = async () => {
    let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
    let service = new ApiServices();
    let isValidSaveSearch = true;
    if (this.handleValidation()) {
      if (this.state.saveSearchName !== "") {
        this.setState({ isLoaded: false });
        let listID = uuidv4();
        let pubmedReviewResponse = await this.updatePubmedSavedFlag(this.state.pubMedXSearchId, true);
        let filterStr = this.generateArrayString(this.state.appliedFilters);
        if (!pubmedReviewResponse.errors) {
          await service.insertUpdatePubMedSaveSearch(
            this.state.saveSearchName,
            `SS_${listID}`,
            username,
            this.state.pubMedXSearchId,
            this.state.searchKeyword,
            filterStr,
            this.state.fromYear,
            this.state.toYear
          );
          this.indexData(`SS_${listID}`, filterStr);
          this.setState({ isLoaded: true });
          this.setState({
            successMessage:
              "The result/selection was pinned successfully to new Save Search.",
            showSuccess: true,
            isInsertSuccess: true
          });

        } else {
          isValidSaveSearch = false;
          if (!isValidSaveSearch) {
            this.setState({ isLoaded: true }, () => {
              this.errorAlertMessage(`Something Went Wrong. Kindly try after some time.`)
            });

          }
        }
      }
      if (this.state.saveSearchName !== "" && isValidSaveSearch) {
        this.setState({
          successMessage:
            "The result was saved successfully to the new save search.",
          showSuccess: true,
          isInsertSuccess: true
        });
      }
    }
  };

  updatePubmedSavedFlag = async (_XSearchId, savedValue = true) => {
    let res = { errors: true }
    let data = [];

    var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}search/save?saved_value=${savedValue}`
    if (window.location.origin === "https://predev-ims.jnj.com") {
      url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}search/save?saved_value=${savedValue}`;
    }
    const options = {
      headers: { "x-search-id": _XSearchId },
    };
    if (await Authentication.isAccessTokenAvailable()) {
      // No Authorization header provided, attach the default one
      const token = await Authentication.getAccessToken();
      options.headers.Authorization = `Bearer ${token}`;
    }
    await axios.post(url, [],
      options).then((response) => {
        //res = response.data
        res = { errors: false }
      }).catch((error) => {
        console.log(error);
        res = { errors: true }
      })
    return res
  };
  handleSuccessClose = async (status) => {
    this.setState({
      showSuccess: status,
      //showPop: false,
      isManage: true,
      isPin: false,
      isinfo: false,
      isLoaded: false
    },
      async () => {
        let username = JSON.parse(
          localStorage.getItem("username")
        ).toLowerCase();
        let service = new ApiServices();
        let apiRes = await service.getPubMedSaveSearches(username);
        this.setState(
          {
            apiResponse: apiRes,
          },
          async () => {
            await this.getPubMedSaveSearchesWithDocIds();
          }
        );
      });
    //this.props.handleClose(false);
  };
  render() {
    const { alertMessageModelColor, alertMessageContent, alertMessageShowModal, isInsertSuccess } = this.state;
    const { confirmMessageContent, confirmMessageShowModal } = this.state;
    if (this.props.width <= 600) {
      return (
        <>
          <Modal
            show={this.state.showPop}
            // size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition modal-90w"
            scrollable={true}
          >
            <div>
              {this.state.isLoaded ? (
                <>
                  {(this.props.selectedResults &&
                    this.props.selectedResults.length > 0) ||
                    this.state.apiResponse.length > 0 ? (
                    <div
                      style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}
                    >
                      <Modal.Header
                        className="gsfModalHeader"
                        style={{ justifyContent: "left", padding: "0.5rem 0" }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            width: "100%",
                            paddingTop: "1%",
                          }}
                        >
                          <Modal.Title>
                            <div className="actionItem-headerPart">
                              {this.props.selectedResults.length > 0 /*&&
                                this.props.selectedResults.length <= 200*/ && !isInsertSuccess && (
                                  <div
                                    onClick={(e) => {
                                      this.setState({
                                        isPin: true,
                                        isManage: false,
                                        isinfo: true,
                                      });
                                    }}
                                    className={
                                      this.state.isPin
                                        ? "active-pin-features-button"
                                        : "pubmed-pin-features-buttons"
                                    }
                                    style={{ margin: "1% 0" }}
                                  >
                                    <span>Save to Save Search</span>
                                  </div>
                                )}
                              <div
                                onClick={(e) => {
                                  this.setState({ isPin: false, isManage: true });
                                }}
                                className={
                                  this.state.isManage
                                    ? "active-pin-features-button"
                                    : "pubmed-pin-features-buttons"
                                }
                                style={{
                                  margin: "1% 0",
                                }} /* className="active-pin-features-button" */
                              >
                                <span>View/Manage Save Searches</span>
                              </div>
                            </div>
                          </Modal.Title>
                        </div>
                      </Modal.Header>
                      <Modal.Body scrollable={true} style={{ height: "45vh" }}>
                        {this.state.isPin && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                {/* <span style={{ color: "black" }}>
                                  My Save Searches
                                </span>{" "}
                                :
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <ul className="save-search-wrapper">
                                      {this.state.apiResponse.map((item) => {
                                        return (
                                          <li key={item.savesearch_id}>
                                            <span>
                                              <input
                                                // disabled={item.docCount > 200}
                                                title={
                                                  item.docCount > 200
                                                    ? "A user may only add a maximum of 200 items in a save search."
                                                    : ""
                                                }
                                                type="checkbox"
                                                value={item.savesearch_id}
                                                className="save-search-checkbox-wrapper"
                                                onChange={e => this.handleCheckBox(e, item.docCount)}
                                              />
                                            </span>
                                            {item.savesearch_name}
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </span>
                                ) : (
                                  <span>
                                    You currently do not have any save searches
                                    created.
                                    <br />
                                  </span>
                                )}
                                <br /> */}
                                <div>
                                  Create A New Save Search By Entering A Title
                                  Below:
                                </div>
                                <input
                                  type="text"
                                  placeholder="Type here"
                                  value={this.state.saveSearchName}
                                  className="save-search-input-box"
                                  onChange={this.handleInput}
                                  onFocus={this.handleOnFocusInput}
                                />
                                <br />
                                <span className="length-info">Name with a maximum of 100 characters.</span>
                                <div className="errorInvalidName">
                                  {this.state.error["pinSaveSearch"]}
                                </div>
                                <br />
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                        {this.state.isManage && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <table className="save-search-view-wrapper">
                                      <tr>
                                        <th style={{ color: "#333" }}>
                                          Save Search Name
                                        </th>
                                        <th
                                          style={{
                                            textAlign: "center",
                                            color: "#333",
                                          }}
                                        >
                                          Actions
                                        </th>
                                      </tr>
                                      <tbody>
                                        {this.state.apiResponse.map((item) => {
                                          return (
                                            <tr key={item.savesearch_id}>
                                              <td>{item.savesearch_name}</td>
                                              <td
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  width: "100%",
                                                  //border: '1px solid',
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span
                                                  onClick={(e) =>
                                                    this.handleViewSaveSearch(
                                                      item.doc_id,
                                                      item.query,
                                                      item.filters,
                                                      item.fromyear,
                                                      item.toyear,
                                                      item.savesearch_name,
                                                      item.savesearch_id,
                                                    )
                                                  }
                                                  title="View"
                                                  className="save-search-action-text"
                                                >
                                                  View
                                                </span>
                                                <span
                                                  onClick={(e) =>
                                                    this.handleRename(
                                                      item.savesearch_id,
                                                      item.savesearch_name
                                                    )
                                                  }
                                                  title="Edit"
                                                  className="save-search-action-text"
                                                >
                                                  Edit
                                                </span>
                                                <span
                                                  onClick={() => this.setState({ shareModal: true })}
                                                  title="Share"
                                                  className="save-search-action-text"
                                                >
                                                  Share
                                                </span>
                                                <span
                                                  title="Remove"
                                                  className="save-search-action-text"
                                                  onClick={(e) =>
                                                    this.handleRemove(
                                                      item.savesearch_id, item.doc_id
                                                    )
                                                  }
                                                >
                                                  Remove
                                                </span>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                    {/*this.state.isinfo === false && <span className="length-info">To Pin/Create the 'Save search' select the items that should be maximum upto 200.</span>*/}
                                  </span>
                                ) : (
                                  <span>
                                    {" "}
                                    You currently do not have any save searches
                                    created.
                                  </span>
                                )}
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </Modal.Body>
                      {this.state.isPin ? (
                        <div className="pin-popup-button-wrapper">
                          {/* <div style={{margin:"1% 0"}}> */}
                          <button
                            className="pin-pop-up-button-cancel"
                            onClick={(e) => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          >
                            Cancel
                          </button>
                          {/* <Button text="Cancel" customColor="#000000" action={() => { this.setState({ showPop: false });this.props.handleClose(false); }} /> */}
                          {/* </div>
                    <div style={{margin:"1% 0"}}> */}
                          <button
                            className="pin-pop-up-button-proceed"
                            onClick={(e) => {
                              this.onclickProceed();
                            }}
                          >
                            Save
                          </button>
                          {/* <Button text="Pin" customColor="#EB1700" action={this.onclickProceed} /> */}
                          {/* </div> */}
                        </div>
                      ) : (
                        <div className="pin-popup-button-wrapper">
                          <Button
                            text="Cancel" customColor="#000000"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ borderLeft: `5px solid #0074B0` }}>
                      {/* <div className="popup-cancel-btn-wrapper">
                        <img src={popCancelBttn} alt="" onClick={(e)=>{this.setState({showPop:false});this.props.handleClose(false)}}/>
                    </div> */}
                      <div style={{ padding: "0 5%" }}>
                        <Modal.Header
                          style={{
                            justifyContent: "center",
                            borderBottomColor: "#0074B0",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <Modal.Title>
                              <div>
                                <img
                                  src={exclaimIcn}
                                  alt=""
                                  className="popup-header-icon-wrapper"
                                />
                              </div>
                              <span style={{ color: "#0074B0" }}>
                                No Save Searches
                              </span>
                            </Modal.Title>
                          </div>
                        </Modal.Header>
                        <Modal.Body
                          scrollable={true}
                          style={{ minHeight: "35vh" }}
                        >
                          <div>
                            It looks like you don't have any save searches created
                            yet.
                          </div>
                        </Modal.Body>
                        <div style={{ textAlign: "center", padding: "3% 0" }}>
                          <Button
                            text="Close"
                            customColor="#0074B0"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: "center", padding: "10%" }}>
                  <img
                    src={imsLoader}
                    alt="Loading Data"
                    style={{ width: "10%" }}
                  />
                </div>
              )}
            </div>
            {this.state.showSuccess && (
              <>
                <SucessReadingList
                  display={this.state.showSuccess}
                  handleClose={(status) => this.handleSuccessClose(status)}
                  data={this.state.successMessage}
                  width={this.props.width}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
            {this.state.showRenamePop && (
              <>
                <RenamePubMedSaveSearchPopup
                  showModal={this.state.showRenamePop}
                  handleClose={(status) => this.handleRenameClose(status)}
                  rlName={this.state.itemtoBeRenamedName}
                  rlID={this.state.itemtoBeRenamedID}
                  width={this.props.width}
                  apiResponse={this.state.apiResponse}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
          </Modal>
          {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
          {(this.state.shareModal) &&
            <SharePubMedModal
              showModal={this.state.shareModal}
              //handleShareThreadToUser={this.handleShareThreadToUser} 
              //handleIsProcessing={this.handleIsProcessing} 
              handleClose={() => this.setState({ shareModal: false })}
            />}
        </>
      );
    } else if (this.props.width <= 1000 && this.props.width > 600) {
      return (
        <>
          <Modal
            show={this.state.showPop}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition"
            scrollable={true}
          >
            <div>
              {this.state.isLoaded ? (
                <>
                  {(this.props.selectedResults &&
                    this.props.selectedResults.length > 0) ||
                    this.state.apiResponse.length > 0 ? (
                    <div
                      style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}
                    >
                      <Modal.Header
                        className="gsfModalHeader"
                        style={{ justifyContent: "left", padding: "0.5rem 0" }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            width: "100%",
                            paddingTop: "1%",
                          }}
                        >
                          <Modal.Title>
                            <div className="actionItem-headerPart">
                              {this.props.selectedResults.length > 0 /*&&
                                this.props.selectedResults.length <= 200*/ && !isInsertSuccess && (
                                  <>
                                    <div
                                      onClick={(e) => {
                                        this.setState({
                                          isPin: true,
                                          isManage: false,
                                          isinfo: true,
                                        });
                                      }}
                                      className={
                                        this.state.isPin
                                          ? "active-pin-features-button"
                                          : "pubmed-pin-features-buttons"
                                      }
                                      style={{ margin: "1% 0" }}
                                    >
                                      <span>Save to Save Search</span>
                                    </div>
                                    <div className="action-button-saperation-line"></div>
                                  </>
                                )}
                              <div
                                onClick={(e) => {
                                  this.setState({ isPin: false, isManage: true });
                                }}
                                className={
                                  this.state.isManage
                                    ? "active-pin-features-button"
                                    : "pubmed-pin-features-buttons"
                                }
                                style={{
                                  margin: "1% 0",
                                }} /* className="active-pin-features-button" */
                              >
                                <span>View/Manage Save Searches</span>
                              </div>
                            </div>
                          </Modal.Title>
                        </div>
                      </Modal.Header>
                      <Modal.Body scrollable={true} style={{ height: "45vh" }}>
                        {this.state.isPin && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                {/* <span style={{ color: "black" }}>
                                  My Save Searches
                                </span>{" "}
                                :
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <ul className="save-search-wrapper">
                                      {this.state.apiResponse.map((item) => {
                                        return (
                                          <li key={item.savesearch_id}>
                                            <span>
                                              <input
                                                // disabled={item.docCount > 200}
                                                title={
                                                  item.docCount > 200
                                                    ? "A user may only add a maximum of 200 items in a save search."
                                                    : ""
                                                }
                                                type="checkbox"
                                                value={item.savesearch_id}
                                                className="save-search-checkbox-wrapper"
                                                onChange={e => this.handleCheckBox(e, item.docCount)}
                                              />
                                            </span>
                                            {item.savesearch_name}
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </span>
                                ) : (
                                  <span>
                                    You currently do not have any save searches
                                    created.
                                    <br />
                                  </span>
                                )}
                                <br /> */}
                                <div>
                                  Create A New Save Search By Entering A Title
                                  Below:
                                </div>
                                <input
                                  type="text"
                                  placeholder="Type here"
                                  value={this.state.saveSearchName}
                                  className="save-search-input-box"
                                  onChange={this.handleInput}
                                  onFocus={this.handleOnFocusInput}
                                />
                                <br />
                                <span className="length-info">Name with a maximum of 100 characters.</span>
                                <div className="errorInvalidName">
                                  {this.state.error["pinSaveSearch"]}
                                </div>
                                <br />
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                        {this.state.isManage && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <table className="save-search-view-wrapper">
                                      <tr>
                                        <th>Save Search Name</th>
                                        <th style={{ textAlign: "center" }}>
                                          Date Saved
                                        </th>
                                        <th style={{ textAlign: "center" }}>
                                          Actions
                                        </th>
                                      </tr>
                                      <tbody>
                                        {this.state.apiResponse.map((item) => {
                                          return (
                                            <tr key={item.savesearch_id}>
                                              <td>{item.savesearch_name}</td>
                                              <td style={{ textAlign: "center" }}>
                                                {moment(item.added_on).format("D-MMM-YYYY")}
                                              </td>
                                              <td
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  width: "100%",
                                                }}
                                              >
                                                <span
                                                  onClick={(e) =>
                                                    this.handleViewSaveSearch(
                                                      item.doc_id,
                                                      item.query,
                                                      item.filters,
                                                      item.fromyear,
                                                      item.toyear,
                                                      item.savesearch_name,
                                                      item.savesearch_id,
                                                    )
                                                  }
                                                  title="View"
                                                  className="save-search-action-text"
                                                >
                                                  View
                                                </span>
                                                <span className="action-items-separate-divider"></span>
                                                <span
                                                  onClick={(e) =>
                                                    this.handleRename(
                                                      item.savesearch_id,
                                                      item.savesearch_name
                                                    )
                                                  }
                                                  title="Edit"
                                                  className="save-search-action-text"
                                                >
                                                  Edit
                                                </span>
                                                <span className="action-items-separate-divider"></span>
                                                <span
                                                  onClick={() => this.setState({ shareModal: true })}
                                                  title="Share"
                                                  className="save-search-action-text"
                                                >
                                                  Share
                                                </span>
                                                <span className="action-items-separate-divider"></span>
                                                <span
                                                  title="Remove"
                                                  className="save-search-action-text"
                                                  onClick={(e) =>
                                                    this.handleRemove(
                                                      item.savesearch_id, item.doc_id
                                                    )
                                                  }
                                                >
                                                  Remove
                                                </span>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                    {/*this.state.isinfo === false && <span className="length-info">To Pin/Create the 'Save search' select the items that should be maximum upto 200.</span>*/}
                                  </span>
                                ) : (
                                  <span>
                                    {" "}
                                    You currently do not have any save searches
                                    created.
                                  </span>
                                )}
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </Modal.Body>
                      {this.state.isPin ? (
                        <div
                          className="gsf-popup-button-wrapper"
                          style={{ width: "40%" }}
                        >
                          <Button
                            text="Cancel" customColor="#000000"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                          <Button
                            text="Save"
                            customColor="#EB1700"
                            action={this.onclickProceed}
                          />
                        </div>
                      ) : (
                        <div className="save-search-button-tablet-wrapper">
                          <Button
                            text="Cancel" customColor="#000000"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ borderLeft: `5px solid #0074B0` }}>
                      {/* <div className="popup-cancel-btn-wrapper">
                        <img src={popCancelBttn} alt="" onClick={(e)=>{this.setState({showPop:false});this.props.handleClose(false)}}/>
                    </div> */}
                      <div style={{ padding: "0 5%" }}>
                        <Modal.Header
                          style={{
                            justifyContent: "center",
                            borderBottomColor: "#0074B0",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <Modal.Title>
                              <div>
                                <img
                                  src={exclaimIcn}
                                  alt=""
                                  className="popup-header-icon-wrapper"
                                />
                              </div>
                              <span style={{ color: "#0074B0" }}>
                                No Save Searches
                              </span>
                            </Modal.Title>
                          </div>
                        </Modal.Header>
                        <Modal.Body
                          scrollable={true}
                          style={{ minHeight: "35vh" }}
                        >
                          <div>
                            It looks like you don't have any save searches created
                            yet. Please use 'Pin' from the desired result/select a
                            few and then click on 'Save Search' icon.
                          </div>
                        </Modal.Body>
                        <div style={{ textAlign: "center", padding: "3% 0" }}>
                          <Button
                            text="Close"
                            customColor="#0074B0"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: "center", padding: "10%" }}>
                  <img
                    src={imsLoader}
                    alt="Loading Data"
                    style={{ width: "10%" }}
                  />
                </div>
              )}
            </div>
            {this.state.showSuccess && (
              <>
                <SucessReadingList
                  display={this.state.showSuccess}
                  handleClose={(status) => this.handleSuccessClose(status)}
                  data={this.state.successMessage}
                  width={this.props.width}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
            {this.state.showRenamePop && (
              <>
                <RenamePubMedSaveSearchPopup
                  showModal={this.state.showRenamePop}
                  handleClose={(status) => this.handleRenameClose(status)}
                  rlName={this.state.itemtoBeRenamedName}
                  rlID={this.state.itemtoBeRenamedID}
                  width={this.props.width}
                  apiResponse={this.state.apiResponse}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
          </Modal>
          {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
          {(this.state.shareModal) &&
            <SharePubMedModal
              showModal={this.state.shareModal}
              //handleShareThreadToUser={this.handleShareThreadToUser} 
              //handleIsProcessing={this.handleIsProcessing} 
              handleClose={() => this.setState({ shareModal: false })}
            />}
        </>
      );
    } else {
      return (
        <>
          <Modal
            show={this.state.showPop}
            //size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition modal-90w"
            scrollable={true}
          >
            <div>
              <div className="popup-cancel-btn-wrapper">
                <img
                  src={popCancelBttn}
                  alt=""
                  onClick={(e) => {
                    this.setState({ showPop: false });
                    this.props.handleClose(false);
                  }}
                />
              </div>
              {this.state.isLoaded ? (
                <>
                  {(this.props.selectedResults &&
                    this.props.selectedResults.length > 0) ||
                    this.state.apiResponse.length > 0 ? (
                    <div
                      style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}
                    >
                      <Modal.Header
                        className="gsfModalHeader"
                        style={{ justifyContent: "left" }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            width:
                              this.props.selectedResults.length > 0
                                /*this.props.selectedResults.length <= 200*/
                                ? "60%"
                                : "30%",
                            paddingTop: "1%",
                          }}
                        >
                          <Modal.Title>
                            <div className="actionItem-headerPart" style={isInsertSuccess ? { justifyContent: "flex-start" } : {}}>
                              {this.props.selectedResults.length > 0 &&
                                this.props.selectedResults.length <= 200 && !isInsertSuccess && (
                                  <>
                                    <div
                                      onClick={(e) => {
                                        this.setState({
                                          isPin: true,
                                          isManage: false,
                                          isinfo: true,
                                        });
                                      }}
                                      className={
                                        this.state.isPin
                                          ? "active-features-button"
                                          : "features-buttons"
                                      }
                                    >
                                      <span>Save to Save Search</span>
                                    </div>
                                    <div className="action-button-saperation-line"></div>
                                  </>
                                )}
                              <div
                                onClick={(e) => {
                                  this.setState({ isPin: false, isManage: true });
                                }}
                                className={
                                  this.state.isManage
                                    ? "active-features-button"
                                    : "features-buttons"
                                } /* className="active-features-button" */
                              >
                                <span>View/Manage Save Searches</span>
                              </div>
                            </div>
                          </Modal.Title>
                        </div>
                      </Modal.Header>
                      <Modal.Body scrollable={true} style={{ height: "44vh" }}>
                        {this.state.isPin && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                {/* <span style={{ color: "black" }}>
                                  My Save Searches
                                </span>{" "}
                                :
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <ul className="save-search-wrapper">
                                      {this.state.apiResponse.map((item) => {
                                        return (
                                          <li
                                            className="savesearchCheckBox"
                                            key={item.savesearch_id}
                                          >
                                            <span>
                                              <input
                                                // disabled={item.docCount > 200}
                                                title={
                                                  item.docCount > 200
                                                    ? "A user may only add a maximum of 200 items in a save search."
                                                    : ""
                                                }
                                                type="checkbox"
                                                value={item.savesearch_id}
                                                className="save-search-checkbox-wrapper"
                                                onChange={e => this.handleCheckBox(e, item.docCount)}
                                              />
                                            </span>
                                            {item.savesearch_name}
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </span>
                                ) : (
                                  <span>
                                    You currently do not have any save searches
                                    created.
                                    <br />
                                  </span>
                                )}
                                <br /> */}
                                <div>
                                  Create A New Save Search By Entering A Title
                                  Below:
                                </div>
                                <input
                                  type="text"
                                  placeholder="Type here"
                                  value={this.state.saveSearchName}
                                  className="save-search-input-box"
                                  onFocus={this.handleOnFocusInput}
                                  onChange={this.handleInput}
                                />
                                <br />
                                <span className="length-info">Name with a maximum of 100 characters.</span>
                                <div className="errorInvalidName">
                                  {this.state.error["pinSaveSearch"]}
                                </div>
                                <br />
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                        {this.state.isManage && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <table className="save-search-view-wrapper">
                                      <tr>
                                        <th>Save Search Name</th>
                                        <th style={{width: '100px', textAlign: "center" }}>
                                          Date Saved
                                        </th>
                                        <th style={{ textAlign: "center", width: '250px', }}>
                                          Shared By
                                        </th>
                                        <th style={{ width: '150px', textAlign: "center" }}>
                                          Actions
                                        </th>
                                      </tr>
                                      <tbody>
                                        {this.state.apiResponse.map((item) => {
                                          return (
                                            <tr key={item.savesearch_id}>
                                              <td title={item.savesearch_name} ><div className="saveSearch_name">{item.savesearch_name} </div></td>
                                              <td style={{ textAlign: "center" }}>
                                                {moment(item.added_on).format("D-MMM-YYYY")}
                                              </td>
                                              <td style={{ textAlign: "center" }}>
                                                <p style={{ margin: 0 }}>{item.shared_from_name && `Name: ${item.shared_from_name}`}</p>
                                                <p style={{ margin: 0 }}> {item.shared_from_email && `Email Id: ${item.shared_from_email}`}</p>
                                              </td>
                                              <td>
                                                <div style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  width: "100%",
                                                }}>
                                                  <span
                                                    onClick={(e) =>
                                                      this.handleViewSaveSearch(
                                                        item.doc_id,
                                                        item.query,
                                                        item.filters,
                                                        item.fromyear,
                                                        item.toyear,
                                                        item.savesearch_name,
                                                        item.savesearch_id,
                                                      )
                                                    }
                                                    title="View"
                                                    className="save-search-action-text"
                                                  >
                                                    View
                                                  </span>
                                                  <span className="action-items-separate-divider"></span>
                                                  <span
                                                    onClick={(e) =>
                                                      this.handleRename(
                                                        item.savesearch_id,
                                                        item.savesearch_name
                                                      )
                                                    }
                                                    title="Edit"
                                                    className="save-search-action-text"
                                                  >
                                                    Edit
                                                  </span>
                                                  <span className="action-items-separate-divider"></span>
                                                  <span
                                                    onClick={() => this.setState({ shareModal: true, saveSearchItem: item })}
                                                    title="Share"
                                                    className="save-search-action-text"
                                                  >
                                                    Share
                                                  </span>
                                                  <span className="action-items-separate-divider"></span>
                                                  <span
                                                    title="Remove"
                                                    className="save-search-action-text"
                                                    onClick={(e) =>
                                                      this.handleRemove(
                                                        item.savesearch_id, item.doc_id
                                                      )
                                                    }
                                                  >
                                                    Remove
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                    {/*this.state.isinfo === false && <span className="length-info">To Pin/Create the 'Save search' select the items that should be maximum upto 200.</span>*/}
                                  </span>
                                ) : (
                                  <span>
                                    {" "}
                                    You currently do not have any save searches
                                    created.
                                  </span>
                                )}
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </Modal.Body>
                      {this.state.isPin ? (
                        <div className="gsf-popup-button-wrapper">
                          <Button
                            text="Cancel" customColor="#000000"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />

                          <Button
                            text="Save"
                            customColor="#EB1700"
                            action={this.onclickProceed}
                          />
                        </div>
                      ) : (
                        <div className="save-search-button-wrapper">
                          <Button
                            text="Cancel" customColor="#000000"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ borderLeft: `5px solid #0074B0` }}>
                      <div className="popup-cancel-btn-wrapper">
                        <img
                          src={popCancelBttn}
                          alt=""
                          onClick={(e) => {
                            this.setState({ showPop: false });
                            this.props.handleClose(false);
                          }}
                        />
                      </div>
                      <div style={{ padding: "0 5%" }}>
                        <Modal.Header
                          style={{
                            justifyContent: "center",
                            borderBottomColor: "#0074B0",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <Modal.Title>
                              <div>
                                <img
                                  src={exclaimIcn}
                                  alt=""
                                  className="popup-header-icon-wrapper"
                                />
                              </div>
                              <span style={{ color: "#0074B0" }}>
                                No Save Searches
                              </span>
                            </Modal.Title>
                          </div>
                        </Modal.Header>
                        <Modal.Body
                          scrollable={true}
                          style={{ minHeight: "25vh" }}
                        >
                          <div>
                            It looks like you don't have any save searches created
                            yet. Please use 'Pin' from the desired result/select a
                            few and then click on 'Save Search' icon.
                          </div>
                        </Modal.Body>
                        <div style={{ textAlign: "center", padding: "3% 0" }}>
                          <Button
                            text="Close"
                            customColor="#0074B0"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: "center", padding: "10%" }}>
                  <img
                    src={imsLoader}
                    alt="Loading Data"
                    style={{ width: "10%" }}
                  />
                </div>
              )}
            </div>
            {this.state.showSuccess && (
              <>
                <SucessReadingList
                  display={this.state.showSuccess}
                  handleClose={(status) => this.handleSuccessClose(status)}
                  data={this.state.successMessage}
                  width={this.props.width}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
            {this.state.showRenamePop && (
              <>
                <RenamePubMedSaveSearchPopup
                  showModal={this.state.showRenamePop}
                  handleClose={(status) => this.handleRenameClose(status)}
                  rlName={this.state.itemtoBeRenamedName}
                  rlID={this.state.itemtoBeRenamedID}
                  width={this.props.width}
                  apiResponse={this.state.apiResponse}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
          </Modal>
          {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
          {(this.state.shareModal) &&
            <SharePubMedModal
              showModal={this.state.shareModal}
              handleClose={() => this.setState({ shareModal: false })}
              saveSearchItem={this.state.saveSearchItem}
              shareFrom={{ 'fromSaveSearch': true, 'fromReviewList': false }}
            />}
        </>
      );
    }
  }
}
export default PubMedSaveSearchPopup;